import { useMemo } from 'react';
import sharedColors from '../config/colors.js';

/**
 * Hook to access color configuration
 * @returns {Object} Color configuration object with theme, semantic, app colors
 */
export const useColors = () => {
  return useMemo(() => sharedColors, []);
};

export default useColors;

